import "./../../assets/css/bootstrap.min.css"
import React, {useEffect, useState} from "react";
import {Col,Row} from "react-bootstrap";
import {CardHeader, CardTitle, Input, Card} from "reactstrap";
import Axios from "axios";
import {mainUrl} from "../../common/common";
import toast, {Toaster} from 'react-hot-toast';
import AddStudent from "./AddStudent";
import ListStudent from "./ListStudent";
import SearchStudent from "./SearchStudent";

function Student() {


    const [programList, setProgramList] = React.useState([]);
    const [departmentList, setDepartmentList] = React.useState([]);
    const [subAdminStatus, setSubAdminStatus] = useState(1);
    const [classList, setClassList] = useState([]);
    const [branchList, setBranchList] = React.useState([]);
    const [yearList, setYearList] = React.useState([]);
    const [list, setList] = React.useState([]);
    const [attachFile, setAttachFiles] = React.useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [localImageStudent, setLocalImageStudent] = useState("");


    const [updateRecordStatus, setUpdateRecordStatus] = React.useState(false);
    const [needObject, setNeedObject] = React.useState({'project_id':0,'province_id':0,'branch_id':0,'class_id':0});
    const [searchParameter, setSearchParameter] = React.useState({
        'employee_id':'',
        'email':'',
        'project_id':'',
        'province_id':'',
        'branch_id':'',
        'position_id':''
    })
    const [searchStatus, setSearchStatus] = React.useState(false);


    useEffect(() => {
        loadData();
    }, []);

    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Header': '*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    }
    function getBranchs() {
        return Axios.get(mainUrl + "getBranch",{headers});
    }
    function getDepartment() {
        return Axios.get(mainUrl + "getDepartment",{headers});
    }
    function getClasss() {
        return Axios.post(mainUrl + "getActiveClass",{},{headers});
    }
    function getProgram() {
        return Axios.get(mainUrl + "getProgram",{headers});
    }
    function getStudents() {
        return Axios.get(mainUrl + "getStudent?page=1",{headers});
    }
    function getYear() {
        return Axios.get(mainUrl + "getYear",{headers});
    }
    const loadData= async()=>{
        await Promise.all([getStudents(),getProgram(),getDepartment(),getBranchs(),getClasss(),getYear()])
            .then(function (results) {
                setList(results[0].data);
                setProgramList(results[1].data);
                setDepartmentList(results[2].data);
                setBranchList(results[3].data);
                setClassList(results[4].data);
                setYearList(results[5].data);
                setIsLoading(true);
            }).catch(function (thrown) {
                if (Axios.isCancel(thrown)) {
                    console.log('Request canceled', thrown.message);
                } else {
                    // handle error
                }
            });;
    }


    const notifyError = (message) => toast.error(message, {
        duration: 6000,
    });
    const notifySuccess = (message) => toast.success(message, {
        duration: 6000,
    });

    return (
        <>
            <div className="content">

                <div>
                    <Row>
                        <Col md="12">
                            <Card className="card-user">
                                <CardHeader style={{backgroundColor: "#80808029"}}>
                                    <CardTitle className="mr-4 ml-4">
                                        <div className="row">
                                            <div className="ml-right">
                                                <h3> User Student </h3>
                                            </div>
                                        </div>
                                    </CardTitle>
                                </CardHeader>
                                <SearchStudent searchStatus={searchStatus} setSearchStatus={setSearchStatus} searchParameter={searchParameter} setSearchParameter={setSearchParameter}  setLocalImageStudent={setLocalImageStudent} localImageStudent={localImageStudent} isLoading={isLoading} setIsLoading={setIsLoading} showModal={showModal} setShowModal={setShowModal} setList={setList}
                                            headers={headers} notifyError={notifyError} notifySuccess={notifySuccess}/>
                            </Card>
                        </Col>
                    </Row>
                    <AddStudent  yearList={yearList} programList={programList}   departmentList={departmentList} branchList={branchList}  setNeedObject={setNeedObject} needObject={needObject} setUpdateRecordStatus={setUpdateRecordStatus} updateRecordStatus={updateRecordStatus} subAdminStatus={subAdminStatus} setSubAdminStatus={setSubAdminStatus} setAttachFiles={setAttachFiles} attachFile={attachFile}  classList={classList}  setLocalImageStudent={setLocalImageStudent} localImageStudent={localImageStudent} isLoading={isLoading} setIsLoading={setIsLoading} showModal={showModal} setShowModal={setShowModal} setList={setList} list={list}
                                 headers={headers} notifyError={notifyError} notifySuccess={notifySuccess}/>
                    <ListStudent  searchStatus={searchStatus} setSearchStatus={setSearchStatus} searchParameter={searchParameter} setSearchParameter={setSearchParameter} setNeedObject={setNeedObject} needObject={needObject} setUpdateRecordStatus={setUpdateRecordStatus} updateRecordStatus={updateRecordStatus} subAdminStatus={subAdminStatus} setSubAdminStatus={setSubAdminStatus} setAttachFiles={setAttachFiles} attachFile={attachFile}  setLocalImageStudent={setLocalImageStudent} localImageStudent={localImageStudent} isLoading={isLoading} setIsLoading={setIsLoading} showModal={showModal} setShowModal={setShowModal} setList={setList} list={list}  headers={headers} notifyError={notifyError}
                                 notifySuccess={notifySuccess}/>
                </div>

            </div>
        </>
    );


}


export default Student;
